import * as s from '~js/utils/selectors';
import * as c from '~js/utils/classes';
import { QuickViewPopup } from '~js/components/quick-view-popup';

const Flickity = themeVendor.Flickity;

export class ProductGrid {
  constructor(container) {
    this.container = container;
    this.body = document.body;
    this.sliders = this.container.querySelectorAll(s.selectors$W.slider);

    if (theme.settings.productGridHover === 'slideshow' && !window.theme.touch) {
      this.productGridSlideshow();
    }

    new QuickViewPopup(this.container);
  }

  /* Product grid slideshow */
  productGridSlideshow() {
    const productMediaSlider = this.container.querySelectorAll(s.selectors$W.productMediaSlider);
    const linkedImages = this.container.querySelectorAll(s.selectors$W.productMediaContainer);

    if (productMediaSlider.length) {
      productMediaSlider.forEach((slider) => {
        const mediaContainer = slider.closest(s.selectors$W.productMediaContainer);
        const progressBar = mediaContainer.querySelector(s.selectors$W.progressBar);
        const countImages = slider.querySelectorAll(s.selectors$W.productMediaSlide).length;
        const autoplaySpeed = 2200;
        const draggable = !this.sliders.length; // Enable dragging if only layout is not Carousel
        let flkty = new Flickity.data(slider);
        let timer = 0;

        let cellSelector = s.selectors$W.productMediaSlide;

        if (!flkty.isActive && countImages > 1) {
          flkty = new Flickity(slider, {
            draggable: draggable,
            cellSelector: cellSelector,
            contain: true,
            wrapAround: true,
            imagesLoaded: true,
            pageDots: false,
            prevNextButtons: false,
            adaptiveHeight: false,
            pauseAutoPlayOnHover: false,
            selectedAttraction: 0.2,
            friction: 1,
            on: {
              ready: () => {
                this.container.style.setProperty('--autoplay-speed', `${autoplaySpeed}ms`);
              },
              change: () => {
                if (timer) {
                  clearTimeout(timer);
                }

                progressBar.classList.remove(c.classes$M.fill);
                progressBar.offsetWidth; // Force a reflow to ensure the remove class takes effect immediately

                requestAnimationFrame(() => {
                  progressBar.classList.add(c.classes$M.fill);
                });

                timer = setTimeout(() => {
                  progressBar.classList.remove(c.classes$M.fill);
                }, autoplaySpeed);
              },
              dragEnd: () => {
                flkty.playPlayer();
              },
            },
          });

          if (!window.theme.touch) {
            mediaContainer.addEventListener('mouseenter', () => {
              progressBar.classList.add(c.classes$M.fill);

              if (timer) {
                clearTimeout(timer);
              }

              timer = setTimeout(() => {
                progressBar.classList.remove(c.classes$M.fill);
              }, autoplaySpeed);

              flkty.options.autoPlay = autoplaySpeed;
              flkty.playPlayer();
            });
            mediaContainer.addEventListener('mouseleave', () => {
              flkty.stopPlayer();
              if (timer) {
                clearTimeout(timer);
              }
              progressBar.classList.remove(c.classes$M.fill);
            });
          }
        }
      });
    }

    // Prevent page redirect on slideshow arrow click
    if (linkedImages.length) {
      linkedImages.forEach((item) => {
        item.addEventListener('click', (e) => {
          if (e.target.matches(s.selectors$W.flickityButton)) {
            e.preventDefault();
          }
        });
      });
    }
  }

  /**
   * Quickview popup close function
   */
  popupClose() {
    const popupProduct = document.querySelector(s.selectors$W.popupProduct);
    if (popupProduct) {
      const popupClose = popupProduct.querySelector(s.selectors$W.popupClose);
      popupClose.dispatchEvent(new Event('click'));
    }
  }

  /**
   * Event callback for Theme Editor `section:block:select` event
   */
  onBlockSelect() {
    if (this.body.classList.contains(c.classes$M.quickViewVisible)) {
      this.popupClose();
    }
  }

  /**
   * Event callback for Theme Editor `section:deselect` event
   */
  onDeselect() {
    if (this.body.classList.contains(c.classes$M.quickViewVisible)) {
      this.popupClose();
    }
  }

  /**
   * Event callback for Theme Editor `section:unload` event
   */
  onUnload() {
    if (this.body.classList.contains(c.classes$M.quickViewVisible)) {
      this.popupClose();
    }
  }
}